const ActionPlanItems = [
  {
    section: "reward_recognition",
    heading: "Reward and Recognition",
    icon: "trophy",
    paragraph:
      "Recognition can be a more powerful ongoing motivator than pay. If you have a low score in this area, find out how to improve it by clicking the button below.",
    modalInfo: [
      {
        question: "Do you feel appropriately rewarded for your work?",
        explanation:
          "It is not unusual to find people who say they are not paid enough. Why wouldn’t they! Pay, however, can only minimise discontent rather than motivating. Let me explain. If somebody feels they are 5% underpaid it niggles away at them, but if they feel they are paid 5% more than they are worth, they don’t work any harder. The first step is to reassure yourself that you are being paid fairly and then see what you can do to improve your pay. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Understand the pay range for the job/jobs in question by discussing this with your manager. (Alternatively, you can look at external @LINK@pay benchmarking information@LINK@.)",
                children: [],
                placeholder: {
                  key: "@LINK@",
                  url: "https://www.payscale.com/index/UK"
                }
              },
              {
                text: "Discuss with your manager where you sit in the range and why. Don’t be angry or disagree, just ask questions to better understand how your pay is set.",
                children: []
              },
              {
                text: "Set out a plan, with your manager’s support, to improve your contribution and as a result your earning potential.",
                children: []
              },
              // {
              //   text:
              //     "Consider what opportunities exist for you to be paid an additional bonus for work and projects completed to a high standard.",
              //   children: []
              // },
              {
                text: "Are there more responsibilities you can take in order to increase your earning power?",
                children: []
              },
              {
                text: "Can you learn new skills or build your knowledge to earn more?",
                children: []
              },
              {
                text: "If your current job will not bring you the pay levels you want, what added skills and abilities will be required for promotion?",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Are you happy with your working hours?",
        explanation:
          "If you score poorly on this question there could be a number of reasons. You should therefore ask yourself the following:",
        explanationChildren: [
          "1. Am I unhappy because I am working too many hours?",
          "2. Am I unhappy because I am working too few hours?",
          "3. Am I unhappy because I would like more flexibility in my working hours?",
          "4. Am I unhappy because I don’t know what my working hours are/will be?",
          "5. Am I unhappy about my working hours because of my pay? (For instance too many hours for the pay you receive or not enough hours for the pay desired.)"
        ],
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Which of the reasons above is making feel unhappy about your working hours?",
                children: []
              },
              {
                text: "If number 1, consider how you might contain workload within the working week. Agree with your manager and colleagues that you will answer emails between 8am to 6pm on working days but not after that or at the weekend.",
                children: []
              },
              {
                text: "If number 2, discuss with your manager what scope exists to do more hours. Can you work in another department too? Is there more training you could do to take on more tasks?",
                children: []
              },
              {
                text: "If number 3, discuss with your manager how you might  work more flexibly. How might that help the organisation as well as you?",
                children: []
              }
              // {
              //   text:
              //     "If number 4 - try to understand from your manager the challenges they have with scheduling. Explain to your manager the challenges you have from not knowing your working hours. Try to find a mutually helpful plan.",
              //   children: []
              // }
            ]
          }
        ]
      },
      {
        question: "Do you feel recognised when you do something well?",
        explanation:
          "Recognition is one of the most powerful motivators and causes of high levels of workplace engagement. Yet on average people are only thanked for what they do once every four and a half months, whereas they are criticised twice a week. Praise creates a positive working environment. If you score poorly on this question you can do the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Praise your manager and colleagues when they do something well. Hopefully your lead might catch on!",
                children: []
              },
              {
                text: "If you manage people you might consider the points below, and also suggest them to your manager.",
                children: []
              },
              {
                text: "Recognise and praise somebody when they do something well.",
                children: []
              },
              {
                text: "If somebody completes work you think they can improve upon use it as an opportunity to coach (i.e ask: ‘how well did you feel that went’, ‘could you have done that differently’, or ‘what more support might you need if you were to do that task again’ etc) so that the individual feels that they are learning rather than being criticised.",
                children: []
              },
              {
                text: "Send somebody a note/email/card when they do something well.",
                children: []
              },
              // {
              //   text:
              //     "Give somebody a small gift (chocolate/flowers/wine) when they do something that has impressed you.",
              //   children: []
              // },
              {
                text: "Recognise individual successes publicly and discuss failures privately.",
                children: []
              },
              {
                text: "For outstanding work, recognise an individual with an email to the CEO/Chairperson to let them know the outstanding work that’s been achieved and by who. For outstanding work, you can suggest applying for an industry award.",
                children: []
              },
              {
                text: "Take every opportunity to recognise and celebrate your team or a member of your team’s success.",
                children: []
              },
              {
                text: "Ask your boss to recognise individuals in your team who have done well.",
                children: []
              }
            ]
          }
        ]
      }
    ],
    supportiveMaterials: [
      {
        type: "Article",
        title: "What should I do if I feel like I am paid unfairly at work? ",
        url: "https://app.workl.com/business-library/browse/articles/6492fd29b8f191001918cf86"
      },
      {
        type: "Article",
        title: "Top tips for negotiating your salary",
        url: "https://app.workl.com/business-library/browse/articles/6481e8adb8f1910019185954"
      },
      {
        type: "Article",
        title: "How can I improve the visibility of my achievements at work?",
        url: "https://app.workl.com/business-library/browse/articles/6494433ab8f191001918d5b8"
      },
      {
        type: "Article",
        title: "Top tips if you feel your achievements are not recognised at work",
        url: "https://app.workl.com/business-library/browse/articles/649448d6b8f191001918d652"
      },
      {
        type: "Article",
        title: "Top tips for getting paid what you deserve in your job",
        url: "https://app.workl.com/business-library/browse/articles/64959798b8f191001918dea8"
      },
      {
        type: "WorkL Answers",
        title: "How to get a pay rise",
        url: "https://app.workl.com/business-library/browse/lectures/6672eaa8e0785b449f488f03"
      },
      {
        type: "WorkL Answers",
        title: "How to understand your payslip",
        url: "https://app.workl.com/business-library/browse/lectures/6672eaf1e0785b449f488ff1"
      },
      {
        type: "WorkL Answers",
        title: "How to ask for more money at work",
        url: "https://app.workl.com/business-library/browse/lectures/66719600e0785b449f478240"
      },
      {
        type: "WorkL Answers",
        title: "How to build confidence in voicing opinions and views at work",
        url: "https://app.workl.com/business-library/browse/lectures/667bd4cee0785b449f4d3594"
      }
    ],
    furtherReading: [
      {
        text: "Find many more relevant materials in our Resource Centre.",
        title: "RESOURCE CENTRE",
        url: "https://app.workl.com/business-library/discover"
      },
      {
        text: "Match with a Mentor using our unique Mentor Matching service.",
        title: "MENTOR MATCHER",
        url: "https://app.workl.com/develop-career"
      }
    ]
  },

  {
    section: "information_sharing",
    heading: "Information Sharing",
    icon: "information",
    paragraph:
      "There is often a disconnect (real or perceived) between the information your managers are providing and what you are receiving. Read the action plan to help you to identify opportunities to improve.",
    modalInfo: [
      {
        question: "Do you have enough information to do your job well?",
        explanation:
          "This question goes to the heart of whether you feel you have been properly trained to do your job well or have enough information on an ongoing basis to do what is required. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Review whether you have been trained effectively to complete your tasks. If not, you should speak to your manager and discuss what’s missing from your training plan.",
                children: []
              },
              {
                text: "Is information readily at hand for you to complete your job efficiently? If not, you should speak to your manager about what you feel is helpful information that’s perhaps come too late, or you didn’t receive. Talk also about how it will help you do a better job, and ask questions to check they understand your point of view.",
                children: []
              },
              {
                text: "Is new information relevant to your job effectively communicated? If not, consider how it might be and discuss this with your manager it can be helpful to consider whether the time of the information, the clarity of message or forum of where communication happens are factors in this.",
                children: []
              },
              {
                text: "Do you have regular team meetings to share updates. Regular team meetings with agendas are a good, stable format that enable information sharing. Regular and more informal ‘stand-up’s can also be a good way to information share across a team and enable information to flow more. Talk about this with your line manager and let them know that you would find this helpful if they don’t already happen.",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Do you feel information is openly shared with you at work?",
        explanation:
          "This question is about whether you understand how the organisation is performing and your role in the organisational outcomes. This question is also exploring whether your manager is being transparent with information. If you score poorly on this question you should consider doing the following: ",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Are there routine meetings to share how the organisation is performing and its plans? If so, do you attend? If not, how might you ask for this information?",
                children: []
              },
              {
                text: "Does the organisation give routine updates online or through reports? Can you see these?",
                children: []
              },
              {
                text: "Are you taking every opportunity to ask questions and feedback about the organisation’s and your department’s performance",
                children: []
              },
              {
                text: "Does the organisation have a newsletter or communication portal to keep employees up to date? Do you keep up to date with this?",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Do you feel your views are heard at work?",
        explanation:
          "If you do not feel your views are listened to then it is unlikely you will feel empowered or engaged to make a full contribution to the organisation. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Ask yourself what you are doing to give feedback to your manager and colleagues. Is it constructive? Positivity intended?",
                children: []
              },
              {
                text: "Are you listening as much as giving your views?",
                children: []
              },
              {
                text: "Try an approach where you and ask for five bits of information before you give one piece of advice or direction.",
                children: []
              },
              {
                text: "Are there good suggestions/ideas schemes or formal feedback sessions you can contribute to?",
                children: []
              },
              {
                text: "Remember everyone has a different viewpoint because everyone has different experiences, education and upbringing. None are right or wrong they are just what people think based on those factors. All contributions should be welcomed to bring diversity of view, collective agreement and understanding. Try to understand why others have the views they have before you jump in to change them!",
                children: []
              }
            ]
          }
        ]
      }
    ],
    supportiveMaterials: [
      {
        type: "Article",
        title:
          "10 helpful tips on how to effectively communicate your views and increase your visibility at work",
        url: "https://app.workl.com/business-library/browse/articles/64ae7f5ab8f19100191990e1"
      },
      {
        type: "Article",
        title: "8 helpful tips on how to ask for constructive feedback at work",
        url: "https://app.workl.com/business-library/browse/articles/64ae74afb8f1910019198f81"
      },
      {
        type: "Article",
        title:
          "How can I communicate to my manager that I feel new information is not effectively shared with me at work?",
        url: "https://app.workl.com/business-library/browse/articles/649317bfb8f191001918d0f6"
      },
      {
        type: "Podcast",
        title: "Squiggly Careers - How to increase your visibility at work",
        url: "https://app.workl.com/business-library/browse/podcasts/6475f9e0b8f1910019181d60"
      },
      {
        type: "Article",
        title: "12 helpful tips to improve team communication at work",
        url: "https://app.workl.com/business-library/browse/articles/649599d7b8f191001918df04"
      },
      {
        type: "WorkL Answers",
        title: "How to build confidence in voicing opinions and views at work",
        url: "https://app.workl.com/business-library/browse/lectures/667bd4cee0785b449f4d3594"
      },
      {
        type: "WorkL Answers",
        title: "Feeling Disrespected at Work? How to communicate effectively with your manager",
        url: "https://app.workl.com/business-library/browse/lectures/66aa48f7e0785b449f5dd658"
      },
      {
        type: "WorkL Answers",
        title: "How to effectively communicate with your employer",
        url: "https://app.workl.com/business-library/browse/lectures/66842117e0785b449f502ee4"
      }
    ],
    furtherReading: [
      {
        text: "Find many more relevant materials in our Resource Centre.",
        title: "RESOURCE CENTRE",
        url: "https://app.workl.com/business-library/discover"
      },
      {
        text: "Start sharing ideas and asking questions via our worldwide platform, the Global Hub",
        title: "GLOBAL HUB",
        url: "https://app.workl.com/global-hub"
      }
    ]
  },

  {
    section: "empowerment",
    heading: "Empowerment",
    icon: "person",
    paragraph:
      "Your empowerment is influenced by both you and those around you. Answering the questions in the Action Plan will help you understand your potential areas to focus on.",
    modalInfo: [
      {
        question: "Are you empowered to make decisions?",
        explanation:
          "When you own something you care more. The secret of empowerment is that you feel you own things, like decisions, projects, action plans. As a result of ownership you feel more accountable and care more about the outcomes. It is also about whether you have the freedom to do what you need to do, to be effective in your job, making the organisation more effective and increasing your earning potential. Empowerment requires your manager to delegate and delegation requires training and coaching. But when done effectively the whole organisation moves more quickly. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Are you clear on the freedoms you have and the flexibility you can exercise in your job? If you’re not, ask your manager to be clearer, and talk through an example to bring this to life for them.",
                children: []
              },
              {
                text: "Do you feel your manager and the organisation set the right parameters for you to make decisions? If not discuss with your manager what more you’d like and why this will benefit everyone.",
                children: []
              },
              {
                text: "Do you have the right level of training and experience for the delegations you have? If not, discuss with your manager what more you need, and try to agree a plan for the next few months. Write down your action plan, and ask your manager to support you by providing time to achieve these actions.",
                children: []
              },
              {
                text: "When things go wrong, and they will, admit it and discuss with your manager what you have learned and if more training or coaching is required.",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Do you have the resources you need to do your job well?",
        explanation:
          "In any business resources are tightly managed. Too much resource means that the business will not make as much profit or be as efficient as it might be. Too little resource places considerable strain on you and the team. It’s a fine balance. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Consider what more you need to do your job well:",
                children: [
                  "More people",
                  "More hours",
                  "Less work/more realistic timeframes",
                  "Better equipment",
                  "Better IT"
                ]
              },
              {
                text: "Talk to your manager about how improving any of the above can improve performance.",
                children: []
              },
              {
                text: "Consider how you might work more efficiently to relieve the pressure on hours and people.",
                children: []
              },
              {
                text: "Consider with the team how you might be able to invest more in resources through generating more income and/or efficiency.",
                children: []
              },
              {
                text: "Do you understand the economics of the organisation and any constraints there may be at this time on additional resources?",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Do you feel trusted to make decisions?",
        explanation:
          "This question is about whether you feel trusted to operate within parameters set by the organisation and your manager. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Do you clearly understand what you can make decisions about? If not, you should ask your manager to clarify.",
                children: []
              },
              {
                text: "Is your manager over-controlling and asking to be consulted about decisions which they have said are delegated to you? If so, reconfirm with your manager what the boundaries are, and seek to understand why they want to be consulted.",
                children: []
              },
              {
                text: "Do you feel confident that you can make the right decision within the parameters set? If not, ask your manager for more training and coaching.",
                children: []
              }
            ]
          }
        ]
      }
    ],
    supportiveMaterials: [
      {
        type: "Article",
        title: "10 helpful tips on how to request an equipment upgrade at work ",
        url: "https://app.workl.com/business-library/browse/articles/64ae846eb8f191001919919e"
      },
      {
        type: "Article",
        title: "Seven tips for having difficult conversations at work",
        url: "https://app.workl.com/business-library/browse/articles/64ae8b79b8f19100191991ff"
      },
      {
        type: "Article",
        title: "9 helpful tips on how to request more responsibility at work",
        url: "https://app.workl.com/business-library/browse/articles/64abffa6b8f1910019197985"
      },
      {
        type: "Article",
        title: "What should I do if I feel I am not trusted to make decisions at work?",
        url: "https://app.workl.com/business-library/browse/podcasts/64ac046bb8f19100191979ee"
      },
      {
        type: "Article",
        title:
          "How to approach your manager if you are confused about your role and responsibilities at work",
        url: "https://app.workl.com/business-library/browse/articles/64ac0681b8f1910019197acc"
      },
      {
        type: "Article",
        title: "10 actionable tips to become more empowered at work",
        url: "https://app.workl.com/business-library/browse/articles/64ac0b38b8f1910019197b3a"
      },
      {
        type: "WorkL Answers",
        title: "Imposter Syndrome : How to tackle it",
        url: "https://app.workl.com/business-library/browse/lectures/66a213e5e0785b449f59e546"
      },
      {
        type: "WorkL Answers",
        title: "Feeling Disrespected at Work? How to communicate effectively with your manager",
        url: "https://app.workl.com/business-library/browse/lectures/66aa48f7e0785b449f5dd658"
      },
      {
        type: "WorkL Answers",
        title: "How to build confidence in voicing opinions and views at work",
        url: "https://app.workl.com/business-library/browse/lectures/667bd4cee0785b449f4d3594"
      },
      {
        type: "WorkL Answers",
        title: "How to build confidence",
        url: "https://app.workl.com/business-library/browse/lectures/667bd319e0785b449f4d2a73"
      },
      {
        type: "WorkL Answers",
        title: "How to effectively communicate with your employer",
        url: "https://app.workl.com/business-library/browse/lectures/66842117e0785b449f502ee4"
      }
    ],
    furtherReading: [
      {
        text: "Find more relevant reading materials in our Resource Centre.",
        title: "RESOURCE CENTRE",
        url: "https://app.workl.com/business-library/discover"
      },
      {
        text: "Need help developing your career? Take our purposefully designed tests to help your Career Development.",
        title: "DEVELOP YOUR CAREER",
        url: "https://app.workl.com/develop-career/your-tests"
      }
    ]
  },

  {
    section: "well_being",
    heading: "Wellbeing",
    icon: "heart",
    paragraph:
      "Healthy employees are more committed, and committed employees are healthier. Find out how to improve your score with our wellbeing action plan.",
    modalInfo: [
      {
        question: "Do you feel the organisation cares for your wellbeing?",
        explanation:
          "If you score poorly on this question, you’ll need to consider whether your concerns are about the organisation in general or the way you are being managed. You can look at scores about management relationships in the Job Satisfaction Action Plan.",
        suggestedActions: [
          {
            heading:
              "If you have a poor score as a result of the organisation not caring, consider the following steps to improve your wellbeing:",
            actions: [
              {
                text: "Are your working hours clearly defined with an understanding of the split between work-time and home-time?",
                children: []
              },
              {
                text: "Are your working hours causing pressure and stress?",
                children: []
              },
              {
                text: "Do you feel equipped for your job - sufficient training, resources, support, ability?",
                children: []
              },
              {
                text: "Can you suggest ideas to your manager to help you and your colleagues be healthier (e.g. gym memberships, classes etc)?",
                children: []
              },
              {
                text: "Can you suggest things to help the organisation promote a healthy lifestyle (e.g. free fruit, encouraging lunchtime walking etc)?",
                children: []
              }
            ]
          },
          {
            heading:
              "If you have a poor score as a result of feeling that your manager doesn’t care, you might consider the following steps:",
            actions: [
              {
                text: "Try to speak to your manager each day. Ask how they are each day - you’ll be surprised how well this works!",
                children: []
              },
              {
                text: "Show concern when they are unwell.",
                children: []
              },
              {
                text: "Wish them a happy break/holiday.",
                children: []
              },
              {
                text: "Take a genuine interest in them and their personal lives.",
                children: []
              },
              {
                text: "All the above actions are suggested as a way to improve the environment and relationship with your manager. If taking the lead on these things doesn’t improve your relationship with your manager, seek support from HR to support you in sharing how you feel with your manager. You may wish to consider another role within the organisation. In some instances, you may wish to consider a role in a new organisation. You can use the @LINK@WorkL Jobs Marketplace@LINK@ - it shows the happier industries to work in and companies to work for.",
                children: [],
                placeholder: {
                  key: "@LINK@",
                  url: "https://app.workl.com/find-work/jobs"
                }
              }
            ]
          }
        ]
      },
      {
        question: "Are you happy with your working environment?",
        explanation:
          "There are a number of things that may lead people to express unhappiness over their working environment. It could be their journey to work, the office temperature, that the office is overcrowded or dark. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Consider which elements of your working environment are causing you to be unhappy and how you might help your manager find a solution to make things better for you. For instance they might not be able to improve your journey to work, but perhaps you could have more flexible working hours.",
                children: []
              },
              {
                text: "Check if your colleagues feel similarly and work together on a plan to improve things.",
                children: []
              },
              {
                text: "If your concern is related to a health and safety issue take immediate action. Notify your manager and all relevant office holders in your organisation. Stop work if there is an imminent danger.",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Do you feel relaxed and calm at work?",
        explanation:
          "There are many reasons why people may feel anxious/depressed coming into work. It may be something to do with their home life and/or their time at work. If you have taken the individual WorkL Workplace Happiness Survey and scored poorly for Wellbeing you will be directed to take the NHS anxiety and depression test, which provides clinical advice.",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "If you are based in the UK and concerned at any time about  your mental wellbeing, visit @LINK@www.nhs.uk/conditions/stress-anxiety-depression/@LINK@",
                children: [],
                placeholder: {
                  key: "@LINK@",
                  url: "https://www.nhs.uk/conditions/stress-anxiety-depression/"
                }
              },
              {
                text: "Try to share your concerns with your manager.",
                children: []
              },
              {
                text: "If it’s your job which is causing concern, discuss what support, training, resources, time etc you might need to feel better about your job/work. The Workplace Happiness Survey will help you identify where your concerns lie. ",
                children: []
              },
              {
                text: "If you conclude you are in the wrong job or role, use the free WorkL Career Developer to find which career and role might suit you best. There is a career path test and a personality test.",
                children: []
              },
              {
                text: "If it is your relationship with your line manager that is the concern but you like your job and the organisation, speak to a member of the HR team or perhaps get a mentor. You can connect with one free of charge by using the WorkL Mentor Matcher.",
                children: []
              }
            ]
          }
        ]
      }
    ],
    supportiveMaterials: [
      {
        type: "Article",
        title: "5 ways to wellbeing at work",
        url: "https://app.workl.com/business-library/browse/articles/648b0796b8f1910019189ae4"
      },
      {
        type: "Article",
        title: "8 actionable steps if you feel like your manager is neglecting your wellbeing at work",
        url: "https://app.workl.com/business-library/browse/articles/64ac0dabb8f1910019197b92"
      },
      {
        type: "Article",
        title: "How can I look after my wellbeing when working from home?",
        url: "https://app.workl.com/business-library/browse/articles/646646d2b8f191001917c1b9"
      },
      {
        type: "Article",
        title: "Mental health tips: 10 really simple things you can do to improve your wellbeing",
        url: "https://app.workl.com/business-library/browse/articles/640a37c1b59dd50018b454f6"
      },
      {
        type: "Article",
        title: "How to support mental health at work",
        url: "https://app.workl.com/business-library/browse/articles/64427286b8f191001916e2fb"
      },
      {
        type: "WorkL Answers",
        title: "How to improve your wellbeing at work",
        url: "https://app.workl.com/business-library/browse/lectures/66744813e0785b449f490671"
      },
      {
        type: "WorkL Answers",
        title: "How can people effectively manage anxiety at work?",
        url: "https://app.workl.com/business-library/browse/lectures/667d8a3ae0785b449f4de3ca"
      },
      {
        type: "WorkL Answers",
        title: "How to manage work priorities and create a work-life balance",
        url: "https://app.workl.com/business-library/browse/lectures/668535aee0785b449f507964"
      },
      {
        type: "WorkL Answers",
        title: " How to communicate effectively with your line manager ",
        url: "https://app.workl.com/business-library/browse/lectures/66aa47ffe0785b449f5dd141"
      },
      {
        type: "Podcast",
        title:
          "The Diary Of A CEO with Steven Bartlett - Want to sleep better? Listen to this: Matthew Walker",
        url: "https://app.workl.com/business-library/browse/podcasts/648c3050b8f191001918a028"
      },
      {
        type: "Podcast",
        title:
          "Feel Better, Live More with Dr Rangan Chatterjee - 7 early signs of burnout and 10 simple & practical tools to help",
        url: "https://app.workl.com/business-library/browse/podcasts/63f36d5db59dd50018b36dda"
      },
      {
        type: "Podcast",
        title:
          "The Liz Earle Wellbeing Show - How to be more in tune with our biological body clocks, with Professor Russell Foster",
        url: "https://app.workl.com/business-library/browse/podcasts/62d71f09e4885600179cfef1"
      },
      {
        type: "Podcast",
        title: "Good Influence - Dr Sam Akbar on Stress and Resilience",
        url: "https://app.workl.com/business-library/browse/podcasts/6451300ab8f1910019173bd6"
      },
      {
        type: "Podcast",
        title: "The Solo Collective - MONEY: What is financial well-being?",
        url: "https://app.workl.com/business-library/browse/podcasts/63809bf19a60e8001778f75d"
      }
    ],
    furtherReading: [
      {
        text: "Find more relevant reading materials in our Resource Centre.",
        title: "RESOURCE CENTRE",
        url: "https://app.workl.com/business-library/discover"
      },
      {
        text: "Match with a Mentor using our unique Mentor Matching service.",
        title: "MENTOR MATCHER",
        url: "https://app.workl.com/develop-career"
      },
      {
        text: "Take our tests to assess which career and role might suit you best.",
        title: "TAKE TESTS",
        url: "https://app.workl.com/develop-career/your-tests"
      }
    ]
  },

  {
    section: "instilling_pride",
    heading: "Instilling Pride",
    icon: "star",
    paragraph:
      "You gain pride from the products and services your organisations provide, the attitudes and behaviour of your colleagues and managers. Find out new ways to think about this using our action plan.",
    modalInfo: [
      {
        question: "Do you feel proud to work for your organisation?",
        explanation:
          "It’s great if you feel proud when you tell someone where you work. Academic research suggests that where people feel a sense of purpose, they contribute more to the organisation’s success and are happier. People working for charities usually score highly on this dimension. If you score poorly on this question you should consider doing the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Do you understand how you contribute to the organisation’s overarching strategic charitable objectives, and the impact of the organisation’s work on producers? If not, how could you get that information?",
                children: []
              },
              // {
              //   text:
              //     "If the organisation does not have a clearly articulated social purpose what might it be? For example if you make mattresses you’re helping people sleep better so that they’re happier. If you grow apples you are preserving and protecting the countryside and helping people eat healthily.",
              //   children: []
              // },
              {
                text: "Do you or your colleagues support a local charity by perhaps donating time or running sponsored events?",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "How likely are you to recommend friends and family to work at your organisation?",
        explanation:
          "One of the surest ways to test if people are happy where they work is to ask if they would recommend where they work to their friends and family. If you wouldn’t recommend your workplace, you need to think if that can be fixed or if you are in the wrong organisation or job. Take a look at the Organisation Satisfaction Matrix. Anarchists are unlikely to talk positively about where they work. For those that fall into the Anarchists part of the chart, it’s likely to affect your wellbeing in the long term, as well as being bad for the organisation.",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Consider why you have scored poorly on this point, referring back to your scores on other questions.",
                children: []
              },
              {
                text: "Do you feel you can address the points raised?",
                children: []
              },
              {
                text: "If you can’t, and your score in the area suggests you are unhappy, consider how you might move to other roles where you work or another organisations where you will be happier. You can use the WorkL Career Developer to test whether you're in the right career and your personality profile matches well with what you are doing, or if you want to consider other jobs in other companies you can visit the @LINK@WorkL Jobs Marketplace@LINK@.",
                children: [],
                placeholder: {
                  key: "@LINK@",
                  url: "https://app.workl.com/find-work/jobs"
                }
              }
            ]
          }
        ]
      },
      {
        question: "Do you feel you are doing something worthwhile?",
        explanation:
          "Everyone wants to feel that they are making a contribution to an organisation’s success and society. There’s a wonderful story about President J F Kennedy visiting NASA to see the space rockets. In the line to meet him was a cleaner. When President Kennedy asked him what his job was, he said “putting a man on the moon!” Teachers and nurses all tend to score highly on this question, but so can others if they understand the contribution they are making.",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Do you appreciate the importance of your role to the success of the organisation?",
                children: []
              },
              {
                text: "Do you appreciate the contribution your organisation is making to society?",
                children: []
              }
            ]
          }
        ]
      }
    ],
    supportiveMaterials: [
      {
        type: "Article",
        title: "7 reasons to be proud of the company you work for",
        url: "https://app.workl.com/business-library/browse/articles/64ad5aa6b8f191001919864d"
      },
      {
        type: "Article",
        title: "Why is it important to be proud of the company you work for?",
        url: "https://app.workl.com/business-library/browse/articles/64ad6aa9b8f1910019198789"
      },
      {
        type: "Article",
        title: "How to request information on the charitable causes the company you work for supports",
        url: "https://app.workl.com/business-library/browse/articles/64b9463db8f191001919dd7b"
      },
      {
        type: "WorkL Answers",
        title: "Why is pride at work important?",
        url: "https://app.workl.com/business-library/browse/lectures/66a2109de0785b449f59d1bb"
      },
      {
        type: "WorkL Answers",
        title: "How to effectively communicate with your employer",
        url: "https://app.workl.com/business-library/browse/lectures/66842117e0785b449f502ee4"
      }
    ],
    furtherReading: [
      {
        text: "Find more relevant reading materials in our Resource Centre.",
        title: "RESOURCE CENTRE",
        url: "https://app.workl.com/business-library/discover"
      },
      {
        text: "Need help developing your career? Take our purposefully designed tests to help your Career Development.",
        title: "DEVELOP YOUR CAREER",
        url: "https://app.workl.com/develop-career/your-tests"
      },
      {
        text: "If you are considering looking for a new role, you can browse jobs for free on the Jobs Marketplace.",
        title: "BROWSE JOBS",
        url: "https://app.workl.com/find-work/jobs"
      }
    ]
  },

  {
    section: "job_satisfaction",
    heading: "Job Satisfaction",
    icon: "thumbsUp",
    paragraph:
      "Do you go home at the end of the day or the end of the week feeling that you have made a positive contribution to your organisation and its customers? If you are struggling in this area, our action plan may help.",
    modalInfo: [
      {
        question: "Do you feel you are being developed?",
        explanation:
          "For many people it is important that they feel they are being developed and as a consequence can increase their earning potential. Even mature employees want to keep learning, and it’s vital for new employees if the organisation is to achieve its potential. Employees want to feel that their boss is developing them rather than just helping make their boss look good. If you score poorly on this question you should consider the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Do you spend time considering where you might improve your performance? You could keep a career diary, recording your areas for development each day. What went well, what went less well and what will you do differently in the future?",
                children: []
              },
              {
                text: "Do you ask your manager and colleagues how you might improve your performance and learn more on the job?",
                children: []
              },
              {
                text: "Have you used the @LINK@WorkL Business Library@LINK@ to find more resources and information to help you develop?",
                children: [],
                placeholder: {
                  key: "@LINK@",
                  url: "https://app.workl.com/business-library"
                }
              },
              {
                text: "Have you used WorkL to search for a mentor or coach?",
                children: []
              },
              {
                text: "Do you have a regular review of performance with your manager to discuss your training and development?",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Do you have a good relationship with your line manager?",
        explanation:
          "The most critical relationship in the workplace is between an individual and their boss. 83% of people leave their jobs because of the poor relationship they have with their line manager, even if they work for a great company. There can be many reasons for this, but if you have a low score in this area you may like to consider the following:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Take an interest in your manager - finding out about their personal life and their hopes and ambitions for work and their wellbeing. If you are interested in them there’s a high chance they’ll be interested in you.",
                children: []
              },
              {
                text: "Recognise that we are all different as we have different skills, experiences and backgrounds.",
                children: []
              },
              {
                text: "Positively encourage your manager to help you improve your performance. Don’t be defensive.",
                children: []
              },
              {
                text: "Try to be positive. A negative outlook and approach will affect you as well as those around you.",
                children: []
              },
              {
                text: "Be interested and engaged in your work.",
                children: []
              },
              {
                text: "If you do not fit the role or organisation, take the positive steps of looking for a new role or organisation.",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Are you treated with respect?",
        explanation:
          "It is hard to be satisfied at work if you do not feel respected by your manager and/or colleagues. If you have a low score for this question you can consider:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "Why do you feel you have not been treated with respect? Perhaps consider the following and see if you identify with any of these points:",
                children: [
                  "You aren’t paid fairly.",
                  "You’re not recognised when you do something well.",
                  "You don’t feel information is shared with you.",
                  "Your views aren’t heard.",
                  "You don’t feel trusted to make decisions.",
                  "Your wellbeing is cared for.",
                  "You don’t do a job which is worthwhile.",
                  "You don’t have a good relationship with your manager.",
                  "You are being taken for granted and not developed."
                ]
              },
              {
                text: "Build action plans around the topics that resonate most with you. Your HR team or a mentor can help you unpick this complex area.",
                children: []
              }
            ]
          }
        ]
      },
      {
        question: "Do you enjoy your job?",
        explanation:
          "It is possible to work for a great organisation, a great boss, have wonderful colleagues but still feel that you are in the wrong job. It is hard to see, if that is the case, how you can feel happy at work over the long term. If you score poorly on this question you should consider:",
        suggestedActions: [
          {
            heading: "Suggested Actions:",
            actions: [
              {
                text: "If you have eliminated the issues listed in the action plan above, and if it is the job itself you don’t enjoy, what would you enjoy doing?",
                children: []
              },
              {
                text: "Is that role available in your department or organisation?",
                children: []
              },
              {
                text: "What training or support is required to achieve your preferred role, and can this organisation support you with that?",
                children: []
              },
              {
                text: "Take control of your own career. There is a career path and personality profile test on WorkL to help you discover where your skills and interests best fit, as well as a @LINK@Jobs Marketplace@LINK@ to search for new roles and see which are the happiest companies to work for.",
                children: [],
                placeholder: {
                  key: "@LINK@",
                  url: "https://app.workl.com/find-work/jobs"
                }
              }
            ]
          }
        ]
      }
    ],
    supportiveMaterials: [
      {
        type: "Article",
        title: "How to request a change in job role at the company you work for",
        url: "https://app.workl.com/business-library/browse/articles/64aff26bb8f1910019199c09"
      },
      {
        type: "Article",
        title: "4 reasons why having a mentor is the most important part of changing your career",
        url: "https://app.workl.com/business-library/browse/articles/61e53d3ce29609001815aefc"
      },
      {
        type: "Article",
        title: "Top tips for building a strong rapport with your manager",
        url: "https://app.workl.com/business-library/browse/articles/64aff492b8f1910019199c7f"
      },
      {
        type: "Article",
        title:
          "10 helpful tips on how to request additional training and development opportunities from your employer",
        url: "https://app.workl.com/business-library/browse/articles/64a7f35eb8f1910019196075"
      },
      {
        type: "Article",
        title: "Easy steps to build a winning career development plan for your growth",
        url: "https://app.workl.com/business-library/browse/articles/63cfde3306d7c70018be4f26"
      },
      {
        type: "Article",
        title: "Developing professional relationships & workplace connections",
        url: "https://app.workl.com/business-library/browse/articles/634e9f9c9a60e80017772c9e"
      },
      {
        type: "Podcast",
        title: "Practical Positivity - How to reset your work-life balance",
        url: "https://app.workl.com/business-library/browse/podcasts/640b5be1b59dd50018b459ba"
      },
      {
        type: "WorkL Answers",
        title: "How to find a mentor",
        url: "https://app.workl.com/business-library/browse/lectures/66c74311e0785b449f705758"
      },
      {
        type: "WorkL Answers",
        title: "Taking next steps in development - how can you develop at work?",
        url: "https://app.workl.com/business-library/browse/lectures/66aa4877e0785b449f5dd3c5"
      },
      {
        type: "WorkL Answers",
        title: "How to communicate effectively with your line manager",
        url: "https://app.workl.com/business-library/browse/lectures/66aa47ffe0785b449f5dd141"
      },
      {
        type: "WorkL Answers",
        title: "How can people improve their happiness at work?",
        url: "https://app.workl.com/business-library/browse/lectures/66c74440e0785b449f7061f1"
      },
      {
        type: "WorkL Answers",
        title: "Finding a work-life balance",
        url: "https://app.workl.com/business-library/browse/lectures/66a21141e0785b449f59d5d1"
      }
    ],
    furtherReading: [
      {
        text: "Find more relevant reading materials in our Resource Centre.",
        title: "RESOURCE CENTRE",
        url: "https://app.workl.com/business-library/discover"
      },
      {
        text: "Match with a Mentor using our unique Mentor Matching service.",
        title: "MENTOR MATCHER",
        url: "https://app.workl.com/develop-career"
      },
      {
        text: "Need help developing your career? Take our purposefully designed tests to help your Career Development.",
        title: "DEVELOP YOUR CAREER",
        url: "https://app.workl.com/develop-career/your-tests"
      }
    ]
  }
]

export default ActionPlanItems
